<for|seg| of=(input.segs || [])>
  <if=seg.tip>
    <span class="ll-w" data-word=(seg.word || false) data-en=(seg.en || false) data-note=(seg.note || false)>${seg.s}</span>
  </if>
  <else>${seg.s}</else>
</for>
